// extracted by mini-css-extract-plugin
export default {"customFileUpload":"SelfieCameraModal_customFileUpload__ROfvr","close":"SelfieCameraModal_close__bRQJk"};